import { t } from 'i18next';
import * as yup from 'yup';

// Max length supported by USD (addressAttention field)
const CONTACT_NAME_MAX_LENGTH = 35;

export const contactFieldsSchema = (nameMaxLength = CONTACT_NAME_MAX_LENGTH) => ({
  contactName: yup
    .string()
    .label(t('labelName'))
    .nullable()
    .max(nameMaxLength, t('errorFieldMaxLength', { field: t('labelName'), length: nameMaxLength })),
  contactPhone: yup.string().label(t('labelPhone')).nullable(),
  contactEmail: yup.string().label(t('labelEmail')).email().nullable(),
  contactCompanyName: yup.string().label(t('labelCompanyName')).nullable(),
});
